import { render, staticRenderFns } from "./PrintingGroupsLists.vue?vue&type=template&id=1371c33a&"
import script from "./PrintingGroupsLists.vue?vue&type=script&lang=js&"
export * from "./PrintingGroupsLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports